import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';


const state = {
    siteAdmin: {
        UserList: [],
    },
};

const getters = {
    getSiteAdminUserList: (state) => state.siteAdmin.UserList,
};

const actions = {    
    async adminCreateUser({dispatch}, user){
        let authHeader = getAuthHeader();
        axios.post("/user/admin/", {user:user}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully created account for ${user.name}!`, {root: true});
            dispatch('adminGetUserList',user.tpa_id);
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error created account for ${user.name}!`, {root: true});
        });
    },

    async adminUpdateUser({dispatch}, user){
        let authHeader = getAuthHeader();
        axios.put("/user/admin/", {user:user}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully updated ${user.name}!`, {root: true});
            dispatch('adminGetUserList',user.tpa_id);
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `...There was an error updating ${user.name}!`, {root: true});
        });
    },

    async adminGetUserList({commit,dispatch},tpa_id){
        let authHeader = getAuthHeader();
        axios.get("/user/admin/list/?tpa_id="+tpa_id, authHeader)
        .then((res) => {
            commit('adminSetUserList',res.data);
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', 'There was an error loading the User list!', {root: true});
        });
    },

    async adminClearUserList({commit}){
        commit('adminClearUserList');
    }
};

const mutations = {
    adminSetUserList(state, list){
        list.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase());
        state.siteAdmin.UserList = list;
    },

    adminClearUserList(state){
        state.siteAdmin.UserList = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};